import React, { createContext, useContext, useState } from 'react'

interface ModalContextType {
  isAnyModalOpen: boolean
  openModal: () => void
  closeModal: () => void
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [modalCount, setModalCount] = useState(0)

  const openModal = () => setModalCount(prev => prev + 1)
  const closeModal = () => setModalCount(prev => Math.max(0, prev - 1))

  return (
    <ModalContext.Provider
      value={{
        isAnyModalOpen: modalCount > 0,
        openModal,
        closeModal
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export const useModalExists = () => {
  const context = useContext(ModalContext)
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider')
  }
  return context
}
